module.exports = __webpack_public_path__ + "static/media/totally_wowed_2.8ebef51c.svg";